import { CButton, CCard, CCardBody, CCardHeader, CCol, CCollapse, CFormSelect, CNav, CNavItem, CNavLink, CRow, CTabContent, CTabPane } from '@coreui/react-pro'
import { useContext, useEffect, useState } from 'react'
import { AppContext } from '../../contexts/App'
import { createSearchParams, useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import CIcon from '@coreui/icons-react'
import { cilArrowTop, cisChevronBottom, cisChevronTop } from '@coreui/icons-pro'
import ScrollToTop from 'react-scroll-to-top'
import Filter from './componenet.filter.sorting'
import GraphBar from './componenet.graph.bar'
import GraphDoughnut from './componenet.graph.doughnut'

export default function Index() {
    const { setMetaData, theme } = useContext(AppContext)
    const [searchParams, setSearchParams] = useSearchParams();
    const [collapseFilterSorting, setCollapseFilterSorting] = useState(searchParams.has('date_after') ||
        searchParams.has('date_before') || searchParams.has('akun') || searchParams.has('rule')
    )
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        setMetaData({
            title: "Graph"
        })
    }, [setMetaData])

    return (<>
        <CRow>
            <CCol md={12}>
                <CButton active={collapseFilterSorting} color={'primary'} size='sm' className='me-2 mb-3' onClick={() => {
                    setCollapseFilterSorting(x => !x)
                }}> Filter <CIcon className='ms-1' icon={collapseFilterSorting ? cisChevronBottom : cisChevronTop} /></CButton>
            </CCol>
        </CRow>
        <CCollapse visible={collapseFilterSorting}>
            <CRow className='mb-3'>
                <CCol>
                    <CCard>
                        <CCardBody>
                            <Filter />
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>
        </CCollapse>
        <CRow>
            <CCol>
                <CCard>
                    <CCardHeader>
                        <CNav variant="tabs" className="card-header-tabs">
                            <CNavItem>
                                <CNavLink href='#bar' active={location.hash !== '#doughnut'}>Bar</CNavLink>
                            </CNavItem>
                            <CNavItem>
                                <CNavLink href='#doughnut' active={location.hash === '#doughnut'}>Doughnut</CNavLink>
                            </CNavItem>
                        </CNav>
                    </CCardHeader>
                    <CCardBody className='overflow-auto'>
                        <CTabContent>
                            <CTabPane visible={location.hash !== '#doughnut'}>
                                <CRow className='mb-2'>
                                    <CCol lg={2} xs={6}>
                                        <CFormSelect
                                            size="sm"
                                            value={searchParams.get('rule') || '0'}
                                            options={[
                                                { label: 'Entire record(s)', value: '0' },
                                                { label: 'Yearly', value: '1' },
                                                { label: 'Monthly', value: '2' },
                                                { label: 'Weekly', value: '3' },
                                                { label: 'Daily', value: '4' },

                                            ]}
                                            onChange={(e) => {
                                                const newsp = createSearchParams(searchParams)
                                                if (e.target.value === "0") newsp.delete('rule')
                                                else newsp.set('rule', e.target.value)
                                                navigate({ 
                                                    pathname: location.pathname,
                                                    hash: location.hash,
                                                    search: newsp.toString()
                                                })
                                            }}
                                        />
                                    </CCol>

                                </CRow>
                                <CRow>
                                    <CCol>
                                        <GraphBar />
                                    </CCol>
                                </CRow>
                            </CTabPane>
                            <CTabPane visible={location.hash === '#doughnut'}>
                                <GraphDoughnut />
                            </CTabPane>
                        </CTabContent>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
        <ScrollToTop smooth component={<CIcon icon={cilArrowTop} />} className={`rounded-circle bg-${theme}`} />
    </>)
}
